import { Button, Form, Popconfirm, Space, Table } from 'antd';
import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { deleteLeavePolicy, getDefaultValidity, loadAllLeavePolicy, updateLeavePolicy } from '../../redux/rtk/features/leavePolicy/leavePolicySlice';
import EditLeavePolicyModal from './editLeavePolicy';


const LeavePolicyTable = () => {
  const { list, loading, defaultValidity } = useSelector((state) => state.leavePolicy);
  console.log("list", list);
  console.log("defaultValidity in table", defaultValidity);

  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();
  const dispatch = useDispatch();
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [selectedPolicy, setSelectedPolicy] = useState(null);
  const [filteredList, setFilteredList] = useState([]);


  useEffect(() => {
    dispatch(loadAllLeavePolicy());
    dispatch(getDefaultValidity());
  }, [dispatch]);

  // Filter list based on default validity_id
  useEffect(() => {
    if (list && defaultValidity && defaultValidity.length > 0) {
      const currentValidityId = defaultValidity[0]?.validity_id;
      console.log("Filtering by validity_id:", currentValidityId);
      
      if (currentValidityId) {
        const filtered = list.filter(policy => policy.validity_id === currentValidityId);
        setFilteredList(filtered);
        console.log("Filtered list:", filtered);
      } else {
        setFilteredList(list);
      }
    } else {
      setFilteredList(list || []);
    }
  }, [list, defaultValidity]);

  const handleDelete = (id) => {
    dispatch(deleteLeavePolicy(id))
      .then(() => {
        // message.success('Leave Policy deleted successfully');
        dispatch(loadAllLeavePolicy());
      })
      .catch((error) => {
        // message.error('Error in deleting leave policy');
      });
  };
  const addKeys = (arr) => arr.map((i, index) => ({ ...i, key: i.id, serial: index + 1 }));

  const handleEditClick = (record) => {
    setSelectedPolicy(record);
    setEditModalVisible(true);
  };

  const handleEditModalCancel = () => {
    setEditModalVisible(false);
    setSelectedPolicy(null);
  };

  const handleEditModalOk = (values) => {
    dispatch(updateLeavePolicy({ id: selectedPolicy.id, values }))
      .then(() => {
        setEditModalVisible(false);
        setSelectedPolicy(null);
        dispatch(loadAllLeavePolicy());
      })
      .catch((error) => {
        console.log("Error updating policy:", error);
      });
  };


  const columns = [
    {
      title: 'Name',
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: 'Leave Type',
      dataIndex: 'leaveType',
      key: 'leaveType',
      render: (leaveType) => leaveType ? leaveType.leaveType : 'N/A',
    },
    {
      title: 'Valid From',
      dataIndex: 'validFrom',
      key: 'validFrom',
      render: (validFrom) => validFrom ? dayjs(validFrom).format('DD-MM-YYYY') : 'N/A',
    },
    {
      title: 'Valid To',
      dataIndex: 'validTo',
      key: 'validTo',
      render: (validTo) => validTo ? dayjs(validTo).format('DD-MM-YYYY') : 'N/A',
    },
    {
      title: 'Yearly Limit',
      dataIndex: 'yearlyLimit',
      key: 'yearlyLimit',
      render: (yearlyLimit) => yearlyLimit !== null ? yearlyLimit : '-',
    },
    {
      title: 'Monthly Limit',
      dataIndex: 'monthlyLimit',
      key: 'monthlyLimit',
      render: (monthlyLimit) => monthlyLimit !== null ? monthlyLimit : '-',
    },
    {
      title: 'Paid',
      dataIndex: 'paid',
      key: 'paid',
      render: (paid) => (paid ? 'Yes' : 'No'),
    },
    {
      title: 'Carry Forward',
      dataIndex: 'carryForward',
      key: 'carryForward',
      render: (carryForward) => (carryForward ? 'Yes' : 'No'),
    },
    {
      title: 'Encashable',
      dataIndex: 'encashable',
      key: 'encashable',
      render: (encashable) => (encashable ? 'Yes' : 'No'),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      render: (status) => (status ? 'Active' : 'Inactive'),
    },
    {
      title: 'Action',
      key: 'action',
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => handleEditClick(record)}>Edit</Button>
          <Popconfirm
            title="Are you sure you want to delete this policy?"
            onConfirm={() => handleDelete(record.key)}
            okText="Yes"
            cancelText="No"
          >
            <Button type="link" danger>Delete</Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Table 
        columns={columns} 
        dataSource={filteredList ? addKeys(filteredList) : []} 
        loading={loading}
        scroll={{ x: 'max-content' }}
      />

      <EditLeavePolicyModal
        visible={editModalVisible}
        onCancel={handleEditModalCancel}
        onOk={handleEditModalOk}
        initialValues={selectedPolicy}
        leaveTypes={leaveTypes}
        loading={loading}
      />
    </>
  );
};

export default LeavePolicyTable;
